import { render, staticRenderFns } from "./ManagePermission.vue?vue&type=template&id=256cc723&"
import script from "./ManagePermission.vue?vue&type=script&lang=js&"
export * from "./ManagePermission.vue?vue&type=script&lang=js&"
import style0 from "./ManagePermission.vue?vue&type=style&index=0&id=256cc723&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports